export const sendToDescriptions: Map<string, string> = new Map([
  ["first_booking", "Only send to the client on their first visit."],
  ["every_booking", "Send to the client on every booking."],
  ["manually", "Send to the client as needed."],
]);